module.exports = __webpack_public_path__ + "static/media/ic_temper.f609084f.png";